import type { ProgramDueItem } from './gamificationTypes';

// The one urgency rule for programs with a due date, on both dashboards: the
// Programs Due flyout's Urgent Zone, and the red "!" and red outline on a
// program card. Overdue, or due within 14 days.
export const URGENT_WITHIN_DAYS = 14;

const DAY = 86400;

/** `dueBy` and `nowSeconds` in unix seconds. */
export const isDueUrgent = (dueBy: number, nowSeconds: number): boolean =>
  dueBy - nowSeconds <= URGENT_WITHIN_DAYS * DAY;

const isItemUrgent = (item: ProgramDueItem, nowSeconds: number): boolean =>
  Boolean(item.isOverdue) || (item.dueBy !== null && isDueUrgent(item.dueBy, nowSeconds));

/** Programs Due split into the Urgent Zone and everything due later. */
export const splitByUrgency = (items: ProgramDueItem[], nowSeconds = Math.floor(Date.now() / 1000)) => ({
  urgent: items.filter((p) => isItemUrgent(p, nowSeconds)),
  later: items.filter((p) => !isItemUrgent(p, nowSeconds))
});
